import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsPermissionsRoute: InvariantJiraRoute = {
	name: 'plan-settings-permissions',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions',
};
